import { render, staticRenderFns } from "./preview_item.vue?vue&type=template&id=6c27952b"
import script from "./preview_item.vue?vue&type=script&lang=js"
export * from "./preview_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports